<template>
  <span :class="satutes_colors_map[props.status?.toLowerCase()] + ' badge'">
    {{ props.status}}
  </span>

</template>
<script setup>
  let props = defineProps({
    status : String
  })

  let satutes_colors_map = {
    in_maintenance: "bg-gray-400",
    ok: "bg-green-400",
    under_maintenance: "bg-yellow-400",
    unknown: "bg-gray-400",
    offline: "bg-red-400",
    online: "bg-green-400",
    offline_maintenance: "bg-yellow-400",
    in_risk: "bg-red-400",
    in_alert: "bg-yellow-400",
    in_warning: "bg-yellow-400",
    in_info: "bg-blue-400"

  }
</script>